const helperMapping = {
  organisationName: {
    title: 'نام سازمان',
  },
  organisationAddress: {
    title: 'آدرس',
  },
  email: {
    title: 'ایمیل',
  },
  mobileNumber: {
    title: 'شماره همراه',
  },
  activitySector: {
    title: 'حوزه فعالیت',
  },
  fullName: {
    title: 'نام ادمین سازمان',
  },
  A1: {
    message: 'خود رهبری',
    color: '#FA8072',
  },
  A2: {
    message: 'هیجان‌خواهی',
    color: '#FFD700',
  },
  A3: {
    message: 'لذت‌جویی',
    color: '#32CD32',
  },
  A4: {
    message: 'موفقیت',
    color: '#2E8B57',
  },
  A5: {
    message: 'قدرت',
    color: '#1E90FF',
  },
  A6: {
    message: 'امنیت',
    color: '#8B008B',
  },
  A7: {
    message: 'هم‌نوایی',
    color: '#FF1493',
  },
  A8: {
    message: 'سنت‌گرایی',
    color: '#DC143C',
  },
  A9: {
    message: 'خیرخواهی',
    color: '#9370DB',
  },
  A10: {
    message: 'جهان‌نگری',
    color: '#4682B4',
  },
  EG1: {
    message: 'اجرایی',
  },
  EG2: {
    message: 'تاثیرگزاری',
  },
  EG3: {
    message: 'برقراری ارتباط',
  },
  EG4: {
    message: 'تفکرراهبردی',
  },
  E1: {
    message: 'کامجو',
    color: '#9017A3',
  },
  E2: {
    message: 'عملگرا',
    color: '#FEBE09',
  },
  E3: {
    message: 'سازگار',
    color: '#0C6AB0',
  },
  E4: {
    message: 'تحلیلگر',
    color: '#CC0056',
  },
  E5: {
    message: 'گرداننده',
    color: '#9017A3',
  },
  E6: {
    message: 'ارزشمدار',
    color: '#9017A3',
  },
  E7: {
    message: 'فرمانده',
    color: '#FEBE09',
  },
  E8: {
    message: 'سخنور',
    color: '#FEBE09',
  },
  E9: {
    message: 'رقابت‌جو',
    color: '#FEBE09',
  },
  E10: {
    message: 'پیوسته‌نگر',
    color: '#0C6AB0',
  },
  E11: {
    message: 'عدالت طلب',
    color: '#9017A3',
  },
  E12: {
    message: 'پیشینه‌گرا',
    color: '#CC0056',
  },
  E13: {
    message: 'محتاط',
    color: '#9017A3',
  },
  E14: {
    message: 'پرورش‌دهنده',
    color: '#0C6AB0',
  },
  E15: {
    message: 'منظم',
    color: '#9017A3',
  },
  E16: {
    message: 'همدل',
    color: '#0C6AB0',
  },
  E17: {
    message: 'متمرکز بر هدف',
    color: '#9017A3',
  },
  E18: {
    message: 'آینده‌نگر',
    color: '#CC0056',
  },
  E19: {
    message: 'تعارض‌گریز',
    color: '#0C6AB0',
  },
  E20: {
    message: 'ایده‌پرداز',
    color: '#CC0056',
  },
  E21: {
    message: 'گردآورنده افراد',
    color: '#CC0056',
  },
  E22: {
    message: 'فردنگر',
    color: '#0C6AB0',
  },
  E23: {
    message: 'کلکسیونر',
    color: '#CC0056',
  },
  E24: {
    message: 'متفکر',
    color: '#CC0056',
  },
  E25: {
    message: 'یادگیرنده',
    color: '#CC0056',
  },
  E26: {
    message: 'ایده‌آل‌گرا',
    color: '#FEBE09',
  },
  E27: {
    message: 'مثبت گرا',
    color: '#0C6AB0',
  },
  E28: {
    message: 'صمیمیت‌طلب',
    color: '#0C6AB0',
  },
  E29: {
    message: 'مسئولیت‌پذیر',
    color: '#9017A3',
  },
  E30: {
    message: 'حلال مسائل',
    color: '#9017A3',
  },
  E31: {
    message: 'متکی به خود',
    color: '#FEBE09',
  },
  E32: {
    message: 'اهمیت طلب',
    color: '#FEBE09',
  },
  E33: {
    message: 'استراتژیک',
    color: '#CC0056',
  },
  E34: {
    message: 'اجتماعی',
    color: '#FEBE09',
  },
  G1: {
    message: 'مشاغل تجاری و فروش',
  },
  G2: {
    message: 'خدماتی',
  },
  G3: {
    message: 'امور حقوقی و اداری',
  },
  G4: {
    message: `آموزشی و تربیتی`,
  },
  G5: {
    message: 'سلامت و روان',
  },
  G6: {
    message: 'صنعتی و فنی',
  },
  G7: {
    message: 'تولیدی و صنایع دستی',
  },
  G8: {
    message: 'فناوری اطلاعات و کسب و کار اینترنتی',
  },
  G9: {
    message: 'بازارهای مالی و امور بانکی',
  },
  G10: {
    message: 'مدیریت و فرماندهی',
  },
  G11: {
    message: 'فرهنگ و هنر',
  },
  G12: {
    message: 'کارآفرینی',
  },
  SG1: {
    message: 'خودشناسی',
  },
  SG2: {
    message: 'خودسازی',
  },
  SG3: {
    message: 'خود توسعه دهی',
  },
  SG4: {
    message: 'خودشکوفایی',
  },
  S1: {
    message: 'تعادل در چرخ زندگی',
  },
  S2: {
    message: 'الگوی رفتارشناسی (DISC)',
  },
  S3: {
    message: 'تنظیم روابط',
  },
  S4: {
    message: 'شناخت رابطه و قوانین رابطه',
  },
  S5: {
    message: 'هوش هیجانی',
  },
  S6: {
    message: 'پارادایم‌های فکری',
  },
  S7: {
    message: 'شناخت محرک‌های رفتاری',
  },
  S8: {
    message: 'تیپ‌شناسی شخصیتی (MBTI)',
  },
  S9: {
    message: 'آشنایی با کهن الگوها',
  },
  S10: {
    message: 'استعدادیابی کلیفتون',
  },
  S11: {
    message: 'ارزش‌های فردی (PVQ)',
  },
  S12: {
    message: 'سلامت روان ( تست نئو)',
  },
  S13: {
    message: 'مهارت‌های خودشناسی',
  },
  S14: {
    message: 'شناخت شمال حقیقی',
  },
  S15: {
    message: 'مسیر تکامل',
  },
  S16: {
    message: 'انواع هوش و استعدادیابی',
  },
  S17: {
    message: 'شناخت پیش‌فرض‌های ذهنی ( طرح‌واره‌ها)',
  },
  S18: {
    message: 'مکانیزم‌های دفاعی غیر ارادی',
  },
  S19: {
    message: 'تست نقشه راه توسعه فردی',
  },
  S20: {
    message: 'شناخت تعارضات درونی',
  },
  S21: {
    message: 'نقش آسیب‌های دوران کودکی در بزرگسالی',
  },
  S22: {
    message: 'تاثیر حمایت‌های عاطفی والدین در روابط عاطفی کودکان در بزرگسالی',
  },
  S23: {
    message: 'شناخت ریشه انواع هیجانات',
  },
  S24: {
    message: 'آشنایی با اضطراب  و تکنیک‌های مدیریت آن',
  },
  S25: {
    message: 'تکنیک‌های زبان و انواع کلام',
  },
  S26: {
    message: 'مهارت مدیریت استرس و فشار روانی در محیط کار',
  },
  S27: {
    message: 'مهارت مدیریت استرس و فشار روانی در خانواده و سالمندی',
  },
  S28: {
    message: 'افزایش انعطاف‌پذیری',
  },
  S29: {
    message: 'رهایی از قضاوت و پیش‌‌داوری',
  },
  S30: {
    message: 'خلق رابطه',
  },
  S31: {
    message: 'کوچینگ توسعه فردی',
  },
  S32: {
    message: 'خودکارآمدی',
  },
  S33: {
    message: 'تعادل کار و زندگی',
  },
  S34: {
    message: 'مهارت هدف‌گذاری هوشمند (SMART)',
  },
  S35: {
    message: 'تقویت عزت نفس و اعتماد به نفس',
  },
  S36: {
    message: 'مهارت تاب‌آوری و سخت‌روی',
  },
  S37: {
    message: 'یادگیری تحولی',
  },
  S38: {
    message: 'شناخت تله‌های زندگی (طرحواره‌های ما)',
  },
  S39: {
    message: 'آشنایی با خطا‌های شناختی',
  },
  S40: {
    message: 'خودآگاهی',
  },
  S41: {
    message: 'حل مسئله و تصمیم‌گیری',
  },
  S42: {
    message: 'تئوری انتخاب',
  },
  S43: {
    message: 'آگاه بودن و ماندن در مسیر',
  },
  S44: {
    message: 'تنظیم عواطف و هیجانات',
  },
  S45: {
    message: 'مهارت بخشش و گذشت',
  },
  S46: {
    message: 'سلامت عاطفی',
  },
  S47: {
    message: 'مدیریت قدرت ذهن، کلام و هیجانات و نقش آن‌ها در رضایت و خوشنودی و یا شکست و درماندگی',
  },
  S48: {
    message: 'بازآفرینی زندگی خود',
  },
  S49: {
    message: 'مدیریت خشم',
  },
  S50: {
    message: 'ارتباط کلامی',
  },
  S51: {
    message: 'زبان بدن',
  },
  S52: {
    message: 'مهارت سخنرانی',
  },
  S53: {
    message: 'مهارت گوش‌دادن فعال',
  },
  S54: {
    message: 'بازی و شوخ طبعی',
  },
  S55: {
    message: 'سواد رسانه',
  },
  S56: {
    message: 'کانال‌های ترجیحی',
  },
  S57: {
    message: 'کد پوشش',
  },
  S58: {
    message: 'تسهیلگری',
  },
  S59: {
    message: 'الهام بخشی',
  },
  S60: {
    message: 'مهارت مذاکره',
  },
  S61: {
    message: 'انگیزه دادن',
  },
  S62: {
    message: 'همکاری',
  },
  S63: {
    message: 'ارائه موثر',
  },
  S64: {
    message: 'هوش هیجانی',
  },
  S65: {
    message: 'هوش فرهنگی',
  },
  S66: {
    message: 'تفکر انتقادی',
  },
  S67: {
    message: 'مسئله‌یابی',
  },
  S68: {
    message: 'حس هنری',
  },
  S69: {
    message: 'کارآفرینی',
  },
  S70: {
    message: 'ذهن نو',
  },
  S71: {
    message: 'تفکری علمی - معلولی',
  },
  S72: {
    message: 'خلق داستان',
  },
  S73: {
    message: 'تبدیل من به ما',
  },
  S74: {
    message: 'مدیریت استعداد',
  },
  S75: {
    message: 'همدلی',
  },
  S76: {
    message: 'تفکر سیستمی',
  },
  S77: {
    message: 'خلق کاریزما',
  },
  S78: {
    message: 'راهبری',
  },
  S79: {
    message: 'شبکه سازی و کار تیمی',
  },
  S80: {
    message: 'روابطه بین فردی',
  },
  S81: {
    message: 'متقاعدسازی',
  },
  S82: {
    message: 'رقابت‌پذیری',
  },
  S83: {
    message: 'مدیریت تعارض',
  },
  S84: {
    message: 'صمیمیت',
  },
  S85: {
    message: 'مدیریت بحران',
  },
  S86: {
    message: 'برندسازی شخصی',
  },
  S87: {
    message: 'برنامه‌ریزی',
  },
  S88: {
    message: 'مدیریت زمان',
  },
  S89: {
    message: 'بهبود فرآیندها',
  },
  S90: {
    message: 'هوش اقتصادی',
  },
  S91: {
    message: 'نقش‌های چندگانه',
  },
  S92: {
    message: 'با خانواده بودن',
  },
  S93: {
    message: 'تحمل تغییر و عدم اطمینان',
  },
  S94: {
    message: 'خودانگیزشی',
  },
  S95: {
    message: 'هوش معنوی',
  },
  S96: {
    message: 'هوش دیجیتال',
  },
  S97: {
    message: 'شهامت',
  },
  S98: {
    message: 'باورها',
  },
  S99: {
    message: 'معنویت',
  },
  S100: {
    message: 'جستجوی معنای زندگی',
  },
  S101: {
    message: 'صلح درون',
  },
  S102: {
    message: 'تمامیت',
  },
  S103: {
    message: 'اصالت',
  },
  S104: {
    message: 'تعهد',
  },
  S105: {
    message: 'منشا اثر بودن',
  },
  S106: {
    message: 'راه - راست',
  },
  S107: {
    message: 'تکامل آگاهانه',
  },
  S108: {
    message: 'وحدت وجودی',
  },
  S109: {
    message: 'من اینجا اکنون',
  },
  S110: {
    message: 'تکنولوژی زبان',
  },
  S111: {
    message: 'اعجاز شیفت‌های کلامی',
  },
  S112: {
    message: 'رهبری کوانتومی',
  },
  S113: {
    message: 'یادگیری کوانتومی',
  },
  S114: {
    message: 'کامل شدن با انواع کلام',
  },
  S115: {
    message: 'عزت نفس',
  },
  S116: {
    message: 'شناخت حدود و مرزها',
  },
  S117: {
    message: 'چشم انداز',
  },
  S118: {
    message: 'مسئولیت‌پذیری',
  },
  PHD: {
    message: 'دکترا',
  },
  ASSOCIATE: {
    message: 'کاردانی',
  },
  BACHELOR: {
    message: 'کارشناسی',
  },
  MASTER: {
    message: 'کارشناسی ارشد',
  },
  M1: {
    message: 'فروردین',
  },
  M2: {
    message: 'اردیبهشت',
  },
  M3: {
    message: 'خرداد',
  },
  M4: {
    message: 'تیر',
  },
  M5: {
    message: 'مرداد',
  },
  M6: {
    message: 'شهریور',
  },
  M7: {
    message: 'مهر',
  },
  M8: {
    message: 'آبان',
  },
  M9: {
    message: 'آذر',
  },
  M10: {
    message: 'دی',
  },
  M11: {
    message: 'بهمن',
  },
  M112: {
    message: 'اسفند',
  },
  '/panel/admin/dashboard': {
    message: 'داشبورد',
  },
  '/panel/admin/user-management': {
    message: 'مدیریت کاربران سازمان',
  },
  '/panel/admin/reports': {
    message: 'گزارشات',
  },
  '/panel/admin/news': {
    message: 'اخبار و اطلاعیه سازمان',
  },
  '/panel/admin/purchases': {
    message: 'خرید های سازمان',
  },
  '/panel/admin/cart': {
    message: 'سبد خرید',
  },
  '/panel/admin/product': {
    message: 'محصولات',
  },
  '/panel/receipt': {
    message: 'رسید تراکنش',
  },
  '/panel/admin/transaction': {
    message: 'تراکنش ها',
  },
  '/panel/admin/job-offer': {
    message: 'فرصت های شفلی',
  },
  '/panel/admin/job-application': {
    message: 'رزومه های دریافتی',
  },
};

export const typeMappingHandler = (key) => {
  return helperMapping[key] || '---';
};
